import * as DashboardConstants from "../../constants/DashboardConstants";
import {getByColName, resultSetSize} from "../charts/DashBoardResultSetUtil";
import {prepareChartData} from "./HighChartsDrawer";
import {calcChartTitle} from "./HighGaugeDrawer";
import {addLinkOptionsToPoint, handleChartClick} from "./HighPieChartDrawer";

/**
 *
 * @param {namaTypes.DTOUserDashbordChartLine} userDashboardChartLine
 * @param h
 * @param w
 * @return {JQuery | jQuery | HTMLElement}
 */
export function createHighColCategLabelsChart(userDashboardChartLine, h, w, widget, Highcharts) {
    let seriesData = [];
    let categories = [];
    let categsWithData = constructCategLabelsValues(userDashboardChartLine, categories);
    if (categsWithData.entries()) {
        for (let [categ, data] of categsWithData.entries()) {
            seriesData.push({name: categ, data: data});
        }
    }
    let widgetId = widget.attr('id');
    let chartData = {
        type: 'column',
    };
    chartData = prepareChartData(chartData, w, h);
    Highcharts.chart(widgetId, {
        chart: chartData,
        plotOptions: {
            column: {
                pointPadding: 0.2,
                borderWidth: 0,
                point: {
                    events: {
                        click: handleChartClick
                    }
                }
            }
        },
        xAxis: {
            categories: categories,
            crosshair: true
        },
        title: {
            text: calcChartTitle(userDashboardChartLine)
        },
        tooltip: {
            headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
            pointFormat: '<br>{point.y}',
            useHTML: true
        },
        yAxis: {
            min: 0,
            title: {
                text: calcChartTitle(userDashboardChartLine)
            }
        },
        series: seriesData
    });
}

/**
 *
 * @param {namaTypes.DTOUserDashbordChartLine} userDashboardChartLine
 * @return {*}
 */
function constructCategLabelsValues(userDashboardChartLine, categories) {
    let params = userDashboardChartLine.parameters;
    let resultSetValues = userDashboardChartLine.resultSet;
    let labelParam = params[DashboardConstants.Param_Label];
    let valueParam = params[DashboardConstants.Param_Value];
    let categParam = params[DashboardConstants.Param_Category];
    let categsWithData = new Map();
    for (let i = 0; i < resultSetSize(resultSetValues); i++) {
        let label = getByColName(i, labelParam, resultSetValues);
        let value = getByColName(i, valueParam, resultSetValues);
        let categ = getByColName(i, categParam, resultSetValues);
        if (!categsWithData.get(categ))
            categsWithData.set(categ, []);
        let point = {y: parseFloat(value)};
        addLinkOptionsToPoint(params, resultSetValues, i, point);
        categsWithData.get(categ).push(point);
        if (!categories.contains(label))
            categories.push(label);
    }
    return categsWithData;
}
